import { Breakpoints } from 'app/model/breakpoints';
import { Breakpoint } from 'app/model/breakpoint';
import { NumberUtils } from 'app/utils/number-utils';

import styleVariables from './exports.scss';

export const BREAKPOINTS: Breakpoints = {
    [Breakpoint.MOBILE]: NumberUtils.parseInteger(styleVariables.breakpointMobile),
    [Breakpoint.MOBILE_LANDSCAPE]: NumberUtils.parseInteger(styleVariables.breakpointMobileLandscape),
    [Breakpoint.TABLET]: NumberUtils.parseInteger(styleVariables.breakpointTablet),
    [Breakpoint.TABLET_LANDSCAPE]: NumberUtils.parseInteger(styleVariables.breakpointTabletLandscape),
    [Breakpoint.DESKTOP]: NumberUtils.parseInteger(styleVariables.breakpointDesktop),
    [Breakpoint.LARGE_DESKTOP]: NumberUtils.parseInteger(styleVariables.breakpointLargeDesktop),
};
